import { useMemo } from 'react';
import { buildNodeTree } from './buildNodeTree';
/**
 * Uses `buildNodeTree` to construct the group hierarchy (root + nested groups),
 * then places each item as a leaf node under its matching group (via `groupKey`).
 * Items with no matching group are appended at the root level.
 *
 * Returns a plain list of items (no grouping) when `groups` or `groupKey` is absent.
 */
export function useGroupItems(options) {
    const { groups, items, groupKey } = options;
    return useMemo(() => {
        if (!groups.length || !groupKey) {
            return items.map((item) => (Object.assign(Object.assign({}, item), { kind: 'item', children: [] })));
        }
        const leafNodes = [];
        const groupsWithKind = groups.map((group) => (Object.assign(Object.assign({}, group), { kind: 'group' })));
        const { nodes, map } = buildNodeTree(groupsWithKind);
        for (const item of items) {
            const itemGroupKey = item[groupKey];
            const parent = map.get(itemGroupKey);
            if (parent) {
                parent.children.push(Object.assign(Object.assign({}, item), { kind: 'item', children: [] }));
            }
            else {
                leafNodes.push(Object.assign(Object.assign({}, item), { kind: 'item', children: [] }));
            }
        }
        return [...nodes, ...leafNodes];
    }, [groups, items, groupKey]);
}
